// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lvC5","label":"styles_label__1sYxs"};